<div class="tooltip" [ngClass]="position">
  <span [innerHTML]="(tooltip | translate) | safeHtml"></span>
</div>
